import { render } from "./ServiceComparison.vue?vue&type=template&id=3c762cc9"
import script from "./ServiceComparison.vue?vue&type=script&lang=js"
export * from "./ServiceComparison.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContentCreator/FeatureHighlight/ServiceComparison.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c762cc9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c762cc9', __exports__)) {
    api.reload('3c762cc9', __exports__)
  }
  
  module.hot.accept("./ServiceComparison.vue?vue&type=template&id=3c762cc9", () => {
    api.rerender('3c762cc9', render)
  })

}


export default __exports__